import React, { SyntheticEvent } from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IProps {
  onClick?: (event: SyntheticEvent) => void;
  className?: string;
}

const CloseIcon = styled(SvgIcon)`
  position: relative;
`;

const Container = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50% !important;
  background-color: ${theme.colors.level2};
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
  color: ${theme.colors.secondary800};
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

export default ({ onClick, className }: IProps) => (
  <Container type="button" className={className} onClick={onClick}>
    <CloseIcon
      name="icon-x-bold"
      width={12}
      height={12}
      customFill="currentColor"
    />
  </Container>
);
